import {
  Alert,
  Button,
  Form,
  FormAlert,
  FormGroup,
  Modal,
  ModalVariant,
  TextInput,
} from '@patternfly/react-core'
import * as React from 'react'
import { useCallback, useEffect, useState } from 'react'

interface Props {
  errorMessage?: string
  isModalOpen: boolean
  name: string
  onCreateProgram: () => void
  onNameChange: (name: string) => void
  onCancel: () => void
}

export const CreateProgramModal = function ({
  errorMessage,
  isModalOpen,
  name,
  onCreateProgram,
  onCancel,
  onNameChange,
}: Props) {
  const [isFormValid, setIsFormValid] = useState<boolean>(false)

  const handleSubmit = useCallback(
    (e: React.FormEvent<HTMLFormElement>) => {
      e.preventDefault()
      onCreateProgram()
    },
    [onCreateProgram],
  )

  useEffect(() => {
    setIsFormValid(name.trim().length > 0)
  }, [name])

  return (
    <React.Fragment>
      <Modal
        variant={ModalVariant.small}
        title="Create New Program"
        isOpen={isModalOpen}
        onClose={onCancel}
        actions={[
          <Button
            key="create"
            variant="primary"
            onClick={onCreateProgram}
            isDisabled={!isFormValid}
          >
            Create
          </Button>,
          <Button key="cancel" variant="link" onClick={onCancel}>
            Cancel
          </Button>,
        ]}
      >
        {errorMessage !== '' ? (
          <FormAlert>
            <Alert
              variant="danger"
              title={errorMessage}
              aria-live="polite"
              isInline
            />
          </FormAlert>
        ) : null}
        <Form isHorizontal onSubmit={handleSubmit}>
          <FormGroup
            label="Name"
            isRequired
            fieldId="name"
            validated={'default'}
          >
            <TextInput value={name} onChange={onNameChange} />
          </FormGroup>
        </Form>
      </Modal>
    </React.Fragment>
  )
}
